import { takeLatest, put, select } from 'redux-saga/effects';
import { actions as listActions } from '../slices/PromotionSlices';

import NetworkHandler from 'utils/network';
import config from 'config';
import NotificationHandler from 'utils/notification';
import ModalHandler from 'utils/modal';

const getSearchPromotion = (state) => state.promotionList.searchPromotion;

function* getPromotionList({ payload }) {
    try {
        const response = yield NetworkHandler.get(`${config.getUrl('bus_promotion')}`, {
            params: payload,
        });
        yield put({ type: listActions.get_list_succeed.type, payload: { ...response } });
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: listActions.get_list_failed.type, payload: error });
    }
}

function* getHistoryList({ payload }) {
    try {
        const response = yield NetworkHandler.get(`${config.getUrl('bus_promotion')}/history`, {
            params: payload,
        });
        yield put({ type: listActions.get_history_succeed.type, payload: { ...response } });
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        // yield put({ type: listActions.get_list_failed.type, payload: error });
    }
}

function* updatePromotion({ payload }) {
    try {
        yield NetworkHandler.post(`${config.getUrl('bus_promotion')}`, {
            ...payload,
        });
        NotificationHandler.notifySuccess('Cập nhật thành công!');

        const searchPromotion = yield select(getSearchPromotion);
        yield put({ type: listActions.get_list.type, payload: { ...searchPromotion } });
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        // yield put({ type: listActions.update_lost_trip_failed.type, payload: error });
    }
}

function* deletePromotion({ payload }) {
    const { id } = payload;
    try {
        const response = yield NetworkHandler.delete(`${config.getUrl('bus_promotion')}/${id}`);
        NotificationHandler.notifySuccess('Xoá quảng cáo thành công!');

        const searchPromotion = yield select(getSearchPromotion);
        yield put({ type: listActions.get_list.type, payload: { ...searchPromotion } });
    } catch (error) {
        NotificationHandler.notifyError(error.message);
    }
}

function* getAllCompanies() {
    try {
        const response = yield NetworkHandler.get(`${config.getUrl('all_companies')}`);
        yield put({ type: listActions.get_all_companies_succeed.type, payload: { ...response } });
    } catch (error) {
        NotificationHandler.notifyError(error.message);
    }
}

function* watchRequestDetail() {
    yield takeLatest(listActions.get_list.type, getPromotionList);
    yield takeLatest(listActions.update_list.type, updatePromotion);
    yield takeLatest(listActions.delete_list.type, deletePromotion);
    yield takeLatest(listActions.get_history_list.type, getHistoryList);
    yield takeLatest(listActions.get_all_companies.type, getAllCompanies);

}

export default watchRequestDetail;
